// Local Development Configuration
// This file contains settings for running the application locally
// Values are loaded from /config.json at runtime

import { getConfig } from "./runtimeConfig";

// Use getters so values are always read from the latest runtime config
export const localConfig = {
  // Environment check
  get isDevelopment() { return getConfig().REACT_APP_ENV === 'development'; },

  // Skip authentication only for local development
  get skipAuth() { return getConfig().REACT_APP_ENV === 'development'; },

  // Local API endpoints
  get apiBaseUrl() { return getConfig().REACT_APP_API_BASE_URL || 'https://biuprodapi.piramalfinance.com/cam-copilot-jenkins'; },

  // Default email for local development
  defaultEmail: 'utkarsh.chaturvedi@piramal.com',

  // Authentication configuration
  get auth() {
    return {
      clientId: getConfig().REACT_APP_CLIENT_ID,
      tenantId: getConfig().REACT_APP_TENANT_ID,
      redirectUri: getConfig().REACT_APP_REDIRECT_URI,
      authApiUrl: getConfig().REACT_APP_AUTH_API_URL
    };
  },

  // Current environment
  get environment() { return getConfig().REACT_APP_ENV || 'development'; },

  // Application name
  get appName() { return getConfig().REACT_APP_NAME || 'PCHFL_CAM_COPILOT_DEV'; },

  // Base URL for download/mail endpoints
  get baseUrl() { return getConfig().REACT_APP_AUTH_API_URL || getConfig().REACT_APP_API_BASE_URL || 'https://biuprodapi.piramalfinance.com'; },

  // Allowed parent origin for postMessage communication (embedded mode)
  get parentOrigin() { return getConfig().REACT_APP_PARENT_ORIGIN || 'https://piramalfinance.com'; },

  // Mock access token for local development
  get mockAccessToken() { return getConfig().REACT_APP_MOCK_ACCESS_TOKEN; },

  // Lambda polling configuration
  get polling() {
    return {
      lambdaUrl: getConfig().REACT_APP_LAMBDA_POLLING_URL ||
                 'https://p4i0f1tg03.execute-api.ap-south-1.amazonaws.com/default/api/job-status',
      apiKey: getConfig().REACT_APP_LAMBDA_API_KEY ||
              'GthHoCvnhZ8UhlLecqlY210pU5Qm9bXGSWtGFAz7',
      intervalMs: parseInt(getConfig().REACT_APP_POLLING_INTERVAL_MS) || 3000,  // 3 seconds
      maxPolls: parseInt(getConfig().REACT_APP_MAX_POLLS) || 60,  // 20 polls = 1 minute
      timeoutMs: parseInt(getConfig().REACT_APP_POLLING_TIMEOUT_MS) || 180000  // 3 minutes
    };
  }
};
